import { navLinks } from "@/mocks/fanCommunity";

const topicLinks = [
  "吃瓜捷克超话",
  "吃瓜捷克后援会",
  "吃瓜捷克应援",
  "吃瓜捷克周边",
  "吃瓜捷克见面会",
];

export default function Footer() {
  return (
    <footer className="bg-accent-700 text-accent-50">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* brand */}
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-accent-950">
                <i className="ri-music-2-line text-xl" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold tracking-wide text-background-50">吃瓜捷克</span>
                <span className="font-display text-[11px] text-background-100/70">ChiguaJieke Fan Community</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
              吃瓜捷克粉丝聚集地，聚合超话签到、后援会分站、应援企划、周边资讯与见面会动态，陪你见证捷克的每一次闪耀。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="#join"
                className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-accent-800 transition-colors hover:bg-background-100"
              >
                <i className="ri-team-line" />
                加入社群
              </a>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/15 text-lg hover:bg-background-50/25">
                <i className="ri-community-line" />
              </span>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/15 text-lg hover:bg-background-50/25">
                <i className="ri-message-3-line" />
              </span>
            </div>
          </div>

          {/* quick links */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-background-100/80 transition-colors hover:text-background-50">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* topics + contact */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">热门话题</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {topicLinks.map((t) => (
                <li key={t}>
                  <span className="flex items-center gap-1.5 text-background-100/80">
                    <i className="ri-hashtag text-xs" />
                    {t}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/20 pt-6 text-xs text-background-100/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 吃瓜捷克粉丝聚集地 · 本页面为粉丝文化展示，文中数据与活动安排仅供参考。</p>
          <p className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-mail-line" />
            联系：fanclub@chiguajieke.cn
          </p>
        </div>
      </div>
    </footer>
  );
}